import { AuthFooterLanguage, AuthWrapper } from '../AuthComponents';
import {
  ForgotPasswordHeader,
  ForgotPasswordForm,
  ForgotPasswordFooter,
} from './ForgotPasswordComponents';
import { useIsSmallScreen } from '../../../hooks';

export const ForgotPassword = () => {
  const isSmallScreen = useIsSmallScreen();

  return (
    <AuthWrapper>
      <ForgotPasswordHeader />
      <ForgotPasswordForm />
      <ForgotPasswordFooter />
      {!isSmallScreen && <AuthFooterLanguage moveToTop />}
    </AuthWrapper>
  );
};
